import type { GetUserDetailsResponse } from "~/api/generated-api";
import type { BetterAuthSessionUser } from "~/lib/better-auth-client";

type UserDetails = GetUserDetailsResponse["data"];

export const DEFAULT_CURRENT_USER: BetterAuthSessionUser = {
  id: "",
  email: "",
  firstName: "",
  lastName: "",
  hasFreeAccess: false,
  authenticationType: "EMAIL",
  archivedAt: null,
  role: "STUDENT",
  bannedAt: null,
  bannedReason: null,
  createdAt: new Date(),
  updatedAt: new Date(),
  isActive: true,
  name: "",
  emailVerified: true,
  username: null,
  phoneNumber: null,
  marketingConsent: false,
  marketingEmailConsent: false,
  deviceVerified: false,
};

export const DEFAULT_USER_DETAILS: UserDetails = {
  contactEmail: null,
  contactPhone: null,
  description: null,
  guardian: null,
  id: "",
  firstName: null,
  lastName: null,
  userAvatarId: "",
  jobTitle: null,
};
